// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2201":"52e8a12a","5706":"8afbfad9","6040":"8afbfad9"}[chunkId] + ".chunk.css";
};